import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { regexPhoneNumber, regexNumeric, decodeDealerToken } from 'helpers/helpers'
import { PGET, POST, GET, GUESTGET, GUESTPOST } from "helpers/api";
import Select from "react-select";
import MapSelector from "./MaoSelect";
import * as yup from 'yup'
import { toast } from "react-toastify";
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown";
import ClickImage from '../../assets/images/click-dark.png'
import QRPAY from '../../assets/images/qr_for_pay.png'
import QRCode from 'qrcode';

export const validationSchema = yup.object().shape({
	firstName: yup.string().required("Ismni kiriting"),
	salePointName: yup.string().required("Do‘kon nomini kiriting"),
	phone: yup.string().required("Telefon raqamni kiriting"),
	userLogin: yup.string().required("Loginni kiriting"),
	password: yup.string().required("Parolni kiriting"),
	legalName: yup.string().required("Yuridik nomi kerak"),
	regionId: yup.number().required("Viloyat tanlang"),
	cityId: yup.number().required("Shahar tanlang"),
	activityType: yup.number().nullable().required("Faoliyat turi tanlang"),
	// STIR (INN) — majburiy emas
	tin: yup.string().nullable(),
	managerId: yup
		.number()
		.nullable()
		.transform((value, originalValue) =>
			originalValue === '' || originalValue === null ? null : Number(originalValue)
		),
	// .required("Dilerni tanlang"),
	fixedUstanovkaSumma: yup
		.number()
		.nullable()
		.transform((value, originalValue) =>
			originalValue === '' || originalValue === null ? null : Number(originalValue)
		),
})

const BASE_URL = 'https://my.click.uz/services/pay?service_id=38416&merchant_id=29935';

const generateUrl = (amount) =>
	`${BASE_URL}&amount=${amount}&transaction_param=ustanovka-1`;


function Register() {
	const { t } = useTranslation();
	const { register, handleSubmit, formState, control, setValue, getValues, reset, trigger, setError, watch } = useForm({
		mode: "onChange",
		resolver: yupResolver(validationSchema),
		defaultValues: { firstName: "", salePointName: "", phone: "", userLogin: "", password: "", gpsPointX: "", gpsPointY: "", regionId: null, cityId: null, legalName: "", managerId: null, activityType: null, tin: "" }
	});
	const [validData, setValidData] = useState({ 'isValid': 3 })
	const { errors } = formState
	const [managerData, setManagerData] = useState([])
	const [activeStep, setActiveStep] = useState(0);
	const [isAnimating, setIsAnimating] = useState(false);
	const [Modal, setModal] = useState(false);
	const [locationData, setLocationData] = useState(null);
	const [DownloadUrlCash, setDownloadUrlCash] = useState('')
	const [allowExistingLogin, setAllowExistingLogin] = useState(false);
	const [showAllowExistingCheckbox, setShowAllowExistingCheckbox] = useState(false);
	const [text, setText] = useState('');
	const [ClickedSum, setClickedSum] = useState(generateUrl(500000));
	const [qrImage, setQrImage] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const submittingRef = useRef(false);
	const [isStepLoading, setIsStepLoading] = useState(false);
	const stepLoadingRef = useRef(false);
	// URL orqali biriktirilgan diler (masalan: #/register?diler=5)
	const [lockedDealerId, setLockedDealerId] = useState(null);
	// STIR (INN) bo'yicha orginfo ma'lumoti: null | { status: 'loading'|'found'|'empty'|'error', data }
	const [orgInfo, setOrgInfo] = useState(null);
	const tinTimerRef = useRef(null);
	const tinRequestRef = useRef(0);

	const handleChange = async (e) => {
		const digitsOnly = e.replace(/\D/g, '');
		let parsed = parseInt(digitsOnly);

		if (!parsed) {
			setText('');
			const fallbackAmount = 500000;
			const fallbackUrl = generateUrl(fallbackAmount);
			setClickedSum(fallbackUrl);
			generateQr(fallbackUrl);
			return;
		}

		if (parsed > 5000000) parsed = 5000000;
		setText(parsed.toString());

		const amount = parsed < 1000 ? 500000 : parsed;
		const finalUrl = generateUrl(amount);

		setClickedSum(finalUrl);
		generateQr(finalUrl);
	};

	const generateQr = async (url) => {
		try {
			const qr = await QRCode.toDataURL(url);
			setQrImage(qr);
		} catch (err) {
			console.error('QR generation error:', err);
		}
	};




	localStorage.setItem("I18N_LANGUAGE", "uz-Latn-UZ")


	async function createUpdate(validatedData) {
		// ❗ Takroriy bosishlarni to‘xtatish (3-4 marta yuborilmasligi uchun)
		if (submittingRef.current) return;
		submittingRef.current = true;
		setIsSubmitting(true);

		try {
			// ✅ isValid === 5 bo‘lsa, xatolik chiqaramiz, lekin formani to‘xtatmaslik mumkin
			if (validData.isValid === 5) {
				toast.error("Parol harf va raqamlardan iborat bo‘lishi kerak");
				// return; // Agar qat'iy talab bo‘lmasa, buni olib tashlang
			}

			const sendData = {
				...validatedData,
				allowExistingLogin: allowExistingLogin,
				phone: '998' + regexNumeric(String(validatedData.phone ?? '')),
				// STIR majburiy emas — bo'sh bo'lsa null yuboriladi
				tin: validatedData.tin ? validatedData.tin : null,
				gpsPointX: locationData?.lat || null,
				gpsPointY: locationData?.lng || null,
				fixedUstanovkaSumma: validatedData.fixedUstanovkaSumma
					? parseInt(validatedData.fixedUstanovkaSumma)
					: null
			};

			const response = await GUESTPOST('/services/admin/api/registration/sale-point', sendData, { loader: true, timeout: 30000 });

			// GUESTPOST xatoda ham reject qilmaydi — error obyektini qaytaradi
			if (response instanceof Error || response?.isAxiosError) {
				toast.error(t('Xatolik yuz berdi'));
				return;
			}

			setModal(true);
			localStorage.removeItem('formData');
		} catch (error) {
			toast.error(t('Xatolik yuz berdi'));
		} finally {
			submittingRef.current = false;
			setIsSubmitting(false);
		}
	}




	async function getManagerData() {
		const response = await GUESTGET('/services/uaa/api/manager-allList', {}, { loader: true })
		if (response) {
			response.unshift({ id: null, firstName: t('-'), lastName: '' }) // Add default option
			setManagerData(response)
		}
	}

	function validatePassword(password) {
		var regexm = new RegExp("^.*[a-zA-Z].*$")
		var regexm2 = new RegExp("^.*[0-9].*$")

		if (password === "") {
			setValidData({ ...validData, 'isValid': 3 })
		}
		if (regexm.test(password) && regexm2.test(password)) {
			setValue('password', password, { shouldValidate: true, shouldDirty: true })
			setValidData({ ...validData, 'password': password, 'isValid': 4 })
		} else {
			setValidData({ ...validData, 'password': password, 'isValid': 5 })
		}
	}


	const category = [
		{ id: 1, name: "Xoz mag" },
		{ id: 2, name: "Aksessuarlar" },
		{ id: 3, name: "O'yinchoqlar" },
		{ id: 4, name: "Oziq-ovqat" },
		{ id: 5, name: "Texnika" },
		{ id: 6, name: "Avto zapchast" },
		{ id: 7, name: "Qurilish mollar" },
		{ id: 8, name: "Mebel" },
		{ id: 9, name: "Parfumeriya" },
		{ id: 10, name: "Avtoximiya" },
		{ id: 11, name: "Kanstovar" },
		{ id: 12, name: "Gigiyenik maxsulotlar" },
		{ id: 13, name: "Bolalar kiyimlari" },
		{ id: 14, name: "Boshqalar" }
	];

	const nextStep = async (step) => {
		// ❗ Takroriy bosishlarni to‘xtatish
		if (stepLoadingRef.current) return;
		stepLoadingRef.current = true;
		setIsStepLoading(true);

		try {
			let fieldsToValidate = [];

			if (activeStep === 0) {
				fieldsToValidate = ['firstName', 'phone', 'salePointName', 'legalName', 'activityType'];
			}

			if (step === 2) {
				let userLogin = getValues('userLogin');

				// ✅ Call both APIs
				let responseLogin = await GUESTGET('/services/uaa/api/check-login-feign?login=' + userLogin, {}, { loader: true });
				let responseLogin2 = await GUESTGET('/services/admin/api/registration/check-user-login?login=' + userLogin, {}, { loader: true });

				const isAvailableInUser = responseLogin.success === true;
				const isAvailableInTemp = responseLogin2.available === true;

				if (isAvailableInUser && isAvailableInTemp) {
					// ✅ Both are good
					fieldsToValidate = ['regionId', 'cityId', 'userLogin', 'password'];
				} else {
					// Login mavjud — egasi (owner) bo'lsagina savdo nuqtasi qo'shishga ruxsat beramiz
					const isOwner = responseLogin2.isOwner === true;

					if (!isOwner) {
						// ❌ Boshqa rol foydalanuvchi logini — qo'shib bo'lmaydi
						setShowAllowExistingCheckbox(false);
						setAllowExistingLogin(false);
						setError('userLogin', {
							type: 'manual',
							message: t('Bu tizimdagi boshqa rol foydalanuvchi logini. Iltimos, yangi login kiriting yoki admin loginini kiriting.')
						});
						return;
					}

					if (allowExistingLogin) {
						// ✅ Owner uchun tasdiqlandi
						fieldsToValidate = ['regionId', 'cityId', 'userLogin', 'password'];
					} else {
						// ❗ Owner uchun checkbox ko'rsatamiz
						setShowAllowExistingCheckbox(true);
						setError('userLogin', {
							type: 'manual',
							message: t('Ushbu login mavjud! Ammo mavjud foydalanuvchi uchun savdo nuqtasini qo\'shishingiz mumkin.')
						});
						return;
					}
				}
			}

			if (fieldsToValidate.length > 0) {
				const isValid = await trigger(fieldsToValidate);
				if (!isValid) return;
			}

			setIsAnimating(true);
			setTimeout(() => {
				setActiveStep((prev) => prev + 1);
				setIsAnimating(false);
			}, 500);
		} finally {
			stepLoadingRef.current = false;
			setIsStepLoading(false);
		}
	};



	const prevStep = () => {
		setIsAnimating(true);
		setTimeout(() => {
			if (activeStep === 2) {
				setAllowExistingLogin(false);
				setShowAllowExistingCheckbox(false);
			}
			setActiveStep((prev) => prev - 1);
			setIsAnimating(false);
		}, 500);
	};
	const [regions] = useState([
		{ id: 1, name: "Andijon viloyati" },
		{ id: 2, name: "Buxoro viloyati" },
		{ id: 3, name: "Jizzax viloyati" },
		{ id: 4, name: "Qashqadaryo viloyati" },
		{ id: 5, name: "Navoiy viloyati" },
		{ id: 6, name: "Namangan viloyati" },
		{ id: 7, name: "Samarqand viloyati" },
		{ id: 8, name: "Surxondaryo viloyati" },
		{ id: 9, name: "Sirdaryo viloyati" },
		{ id: 10, name: "Toshkent shahri" },
		{ id: 11, name: "Toshkent viloyati" },
		{ id: 12, name: "Fargʻona viloyati" },
		{ id: 13, name: "Xorazm viloyati" },
		{ id: 14, name: "Qoraqalpogʻiston Respublikasi" }
	]);

	const [cities, setCities] = useState([])

	async function selectRegion(option) {
		setValue('regionId', option.id, { shouldValidate: true, shouldDirty: true })
		setValue('cityId', null)
		const response = await GUESTGET('/services/admin/api/city-helper/' + option.id)
		if (response.length > 0) {
			setCities(response)
		}
	}

	const handleLoginChange = (e) => {
		// Allow only a-z, 0-9, _
		const cleaned = e.target.value.replace(/[^a-z0-9_]/g, '');
		setValue('userLogin', cleaned, { shouldValidate: true });

		// User is editing login - clear override
		setAllowExistingLogin(false);
		setShowAllowExistingCheckbox(false);
	};
	const handleYATTChange = (e) => {
		// Allow only a-z, 0-9, _
		const cleaned = e.target.value.replace(/[^a-zA-Z0-9_ ]/g, '');
		setValue('legalName', cleaned, { shouldValidate: true });
	};

	// ==== STIR (INN) → tashkilot ma'lumoti ====
	// To'g'ridan-to'g'ri brauzerdan orginfo.uz'dan olinadi. orginfo javobga
	// CORS sarlavhasini qo'shmaydi, shuning uchun o'qish proksisi orqali
	// so'raladi (r.jina.ai sahifani matn ko'rinishida va CORS bilan qaytaradi).
	const ORG_INFO_URL = (stir) => `https://r.jina.ai/https://orginfo.uz/ru/search/organizations/?q=${stir}`;

	// Qidiruv natijasidagi bitta yozuv quyidagi ko'rinishda keladi:
	// [STIR Holati ![calendar](...) 28.03.2001 ###### NOMI ![location](...) MANZIL](https://orginfo.uz/ru/organization/<slug>/)
	function parseOrgInfo(text, stir) {
		if (!text) return null;

		// Yozuv bitta qatorda keladi. Matn ichida rasm belgilari ([...]) borligi
		// uchun regex bilan emas, qator boshiga qarab topamiz.
		const line = text
			.split('\n')
			.map((l) => l.trim())
			.find((l) => l.startsWith('[' + stir) && l.includes('/organization/'));
		if (!line) return null;

		const urlMatch = line.match(/\((https:\/\/orginfo\.uz\/[a-z]{2}\/organization\/[^)]+)\)\s*$/);
		const body = line.slice(1, line.lastIndexOf(']('));

		// Rasm belgilaridan (calendar / location) foydalanib bo'laklarga ajratamiz
		const [head = '', tail = ''] = body.split(/!\[[^\]]*calendar[^\]]*\]\([^)]*\)/);
		const [middle = '', addressPart = ''] = tail.split(/!\[[^\]]*location[^\]]*\]\([^)]*\)/);

		const clean = (s) => s.replace(/\s+/g, ' ').trim();
		const dateMatch = middle.match(/\d{2}\.\d{2}\.\d{4}/);
		const name = clean(middle.replace(/\d{2}\.\d{2}\.\d{4}/, '').replace(/#+/g, ' '));
		if (!name) return null;

		return {
			name,
			status: clean(head.replace(stir, '')),
			registrationDate: dateMatch ? dateMatch[0] : '',
			address: clean(addressPart),
			url: urlMatch ? urlMatch[1] : '',
		};
	}

	async function lookupOrgInfo(tin) {
		const requestId = ++tinRequestRef.current;
		setOrgInfo({ status: 'loading' });
		try {
			const response = await fetch(ORG_INFO_URL(tin));
			if (!response.ok) throw new Error('orginfo javob bermadi');
			const text = await response.text();
			// Foydalanuvchi orada boshqa STIR yozgan bo'lsa — eski javobni tashlaymiz
			if (requestId !== tinRequestRef.current) return;

			const data = parseOrgInfo(text, tin);
			setOrgInfo(data ? { status: 'found', data } : { status: 'empty' });
		} catch (error) {
			if (requestId !== tinRequestRef.current) return;
			setOrgInfo({ status: 'error' });
		}
	}

	const handleTinChange = (e) => {
		const cleaned = e.target.value.replace(/\D/g, '').slice(0, 9);
		setValue('tin', cleaned, { shouldValidate: true });

		if (tinTimerRef.current) clearTimeout(tinTimerRef.current);
		tinRequestRef.current++; // eski so'rov javobini bekor qilamiz
		setOrgInfo(null);

		// STIR 9 xonali bo'lgandagina so'rov yuboriladi
		if (cleaned.length === 9) {
			tinTimerRef.current = setTimeout(() => lookupOrgInfo(cleaned), 400);
		}
	};

	useEffect(() => {
		return () => {
			if (tinTimerRef.current) clearTimeout(tinTimerRef.current);
		};
	}, []);

	useEffect(async () => {
		// setActiveStep(0)
		const qr = await QRCode.toDataURL(
			`https://my.click.uz/services/pay?service_id=38416&merchant_id=29935&amount=${500000}&transaction_param=ustanovka-1`
		);
		setQrImage(qr);
		checkForUpdateFromGitHub()
		getManagerData()
	}, [])

	async function checkForUpdateFromGitHub() {
		const GITHUB_TOKEN = "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"; // PAT tokeningni shu yerga qo'y

		try {
			const response = await fetch("https://api.github.com/repos/JaMeS-18-18/updater_test/releases/latest", {
				headers: {
					"Authorization": `token ${GITHUB_TOKEN}`,
					"Accept": "application/vnd.github.v3+json"
				}
			});

			const data = await response.json();
			// const latestVersion = data.tag_name.replace("v", ""); // "v1.0.3" → "1.0.3"
			const exeAsset = data.assets.find(asset => asset.name.endsWith(".exe"));
			if (!exeAsset) {
				return toast.error("fayl topilmadi. Iltimos, keyinroq qayta urinib ko'ring.");
			}
			setDownloadUrlCash(exeAsset.browser_download_url);

		} catch (error) {
			console.error(JSON.stringify(error));
		}
	}

	// click linki
	const clickReturnUrl = `${window.location.origin}/#/register?paid=1`;

	useEffect(() => {
		// Masalan: "#/register?paid=1"
		const hash = window.location.hash;

		// Hash ichidan query stringni ajratamiz
		const queryString = hash.includes('?') ? hash.split('?')[1] : '';

		const urlParams = new URLSearchParams(queryString);
		const paid = urlParams.get('paid');

		if (paid === '1') {
			const savedData = localStorage.getItem('formData');
			if (savedData) {
				const parsedData = JSON.parse(savedData);
				Object.entries(parsedData).forEach(([key, value]) => {
					setValue(key, value);
				});
				createUpdate(parsedData);
			}

			// Hash ichidagi query params ni olib tashlaymiz
			const cleanedHash = hash.split('?')[0]; // "#/register"
			window.location.hash = cleanedHash;
		}
	}, []);



	// Diler linki orqali kirilganda dilerni avtomatik biriktiramiz
	// Masalan: https://admin.idokon.uz/#/register?diler=dkthm  (token, ochiq id emas)
	useEffect(() => {
		const hash = window.location.hash;
		const queryString = hash.includes('?') ? hash.split('?')[1] : '';
		const urlParams = new URLSearchParams(queryString);
		const token = urlParams.get('diler');
		const id = decodeDealerToken(token);

		if (id != null) {
			setLockedDealerId(id);
			setValue('managerId', id, { shouldValidate: true, shouldDirty: true });
		}
	}, []);

	useEffect(() => {
		// Form o'zgarayotganini kuzatish
		const subscription = watch((value) => {
			localStorage.setItem('formData', JSON.stringify(value));
		});

		return () => subscription.unsubscribe();
	}, [watch]);

	useEffect(() => {
		console.log('formState errors:', errors);
		console.log('isValid:', formState.isValid);
	}, [formState]);

	// URL orqali biriktirilgan dilerni (agar ro'yxatdan topilsa) ko'rsatish uchun
	const lockedDealer = lockedDealerId != null
		? managerData.find((option) => option?.id === lockedDealerId)
		: null;

	return (
		<>
			<div className="authentication-bg">

				<div className="account-pages h-100 vertical-center">
					<div className="container">
						<div className="row align-items-center justify-content-center">
							<div className="col-md-8 col-lg-6 ">
								<div className="bg-white rounded-2 p-3 auth-card">
									<div className="text-center my-2">
										<div className="d-flex justify-content-center w-100 align-items-center" style={{ position: 'relative' }}>
											<h4 className="">
												{t('REGISTER')}
											</h4>
											<div className="" style={{ position: 'absolute', left: -20, top: -30 }}>
												<LanguageDropdown />
											</div>
										</div>
										<div className="custom-stepper mt-4 mb-4">
											<div className="step-container">
												<div className={`step ${activeStep >= 0 ? 'active' : ''}`}>
													<div className="step-number">1</div>
													<div className="step-title">{t('PERSONAL_INFORMATION')}</div>
												</div>
												<div className="step-line"></div>
												<div className={`step ${activeStep >= 1 ? 'active' : ''}`}>
													<div className="step-number">2</div>
													<div className="step-title">{t('ACCOUNT_INFORMATION')}</div>
												</div>
												<div className="step-line"></div>
												<div className={`step ${activeStep >= 2 ? 'active' : ''}`}>
													<div className="step-number">3</div>
													<div className="step-title">{t('MY_LOCATION')}</div>
												</div>
												<div className="step-line"></div>
												<div className={`step ${activeStep >= 3 ? 'active' : ''}`}>
													<div className="step-number">4</div>
													<div className="step-title">{t('PAYMENT_METHOD')}</div>
												</div>
											</div>
										</div>
									</div>
									<form className="form-horizontal" onSubmit={async (e) => {
										e.preventDefault();
										if (submittingRef.current) return; // ❌ Takroriy yuborishni to‘xtatish
										const isValid = await trigger(); // 🟢 Hammasini tekshiradi
										if (!isValid) {
											return; // ❌ API chaqilmasin
										}
										handleSubmit(createUpdate)(e); // 🟢 Formani submit qilish
									}} onKeyDown={(e) => {
										if (e.key === 'Enter') {
											const target = e.target;
											const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA';
											if (!isInput) e.preventDefault();
										}
									}}
										autoComplete="off">
										<div className={`form-step ${isAnimating ? 'fade-out' : 'fade-in'}`} style={{ display: activeStep === 0 ? 'block' : 'none' }}>
											<div className="form-grid">
												<div className="form-group">
													<label>{t('FULL_NAME')}<span className="required-mark">*</span></label>
													<input type="text" className="form-control" name="firstName" {...register('firstName')} />
													<span className="text-danger text-sm">{errors.firstName?.message}</span>
												</div>

												<div className="form-group">
													<label>{t('SALE_POINT_NAME')}<span className="required-mark">*</span></label>
													<input type="text" className="form-control" name="salePointName" {...register('salePointName')} />
													<span className="text-danger text-sm">{errors.salePointName?.message}</span>
												</div>
											</div>
											<div className="form-grid">
											<div className="form-group">
												<label>{t('LEGAL_INFORMATION')}<span className="required-mark">*</span></label>
												<input type="text" className="form-control"
													{...register('legalName', {
														required: errors.legalName?.message,
														pattern: {
															value: /^[a-zA-Z0-9_ ]*$/,
															message: 'Only lowercase letters, numbers, and underscores are allowed'
														}
													})}
													onChange={handleYATTChange}
													name="legalName" />
												<span className="text-danger text-sm">{errors.legalName?.message}</span>
											</div>
											<div className="form-group">
												<label>{t('KIND_OF_ACTIVITY')}</label>
												<Controller
													name="activityType"
													control={control}
													render={({ field }) =>
														<Select
															{...field}
															options={category}
															placeholder=""
															value={category.find(option => option.id === field.value)}
															onChange={(selectedOption) => field.onChange(selectedOption.id)}
															noOptionsMessage={() => t('LIST_IS_EMPTY')}
															getOptionLabel={(option) => option?.name}
															getOptionValue={(option) => option?.id}
														/>}
												/>
												<span className="text-danger text-sm">{errors.activityType?.message}</span>

											</div>
											</div>
											<div className="form-group">
												<label>{t('PHONE')}</label>
												<div className="input-group">
													<span className="input-group-text">998</span>
													<input type="number" className="form-control" name="phone" {...register('phone')} />
												</div>
												<span className="text-danger text-sm">{errors.phone?.message}</span>
											</div>

											<div className="d-flex w-100 mt-4">
												<button type="button" className="btn btn-success w-100" onClick={nextStep} disabled={isStepLoading}>
													{isStepLoading ? (
														<>
															<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
															{t('Yuklanmoqda...')}
														</>
													) : t('NEXT')}
												</button>
											</div>
										</div>

										<div className={`form-step step-account ${isAnimating ? 'fade-out' : 'fade-in'}`} style={{ display: activeStep === 1 ? 'block' : 'none' }}>

											<div className="form-grid">
											<div className="form-group">
												<label>{t('REGION')}<span className="required-mark">*</span></label>
												<Controller
													name="regionId"
													control={control}
													render={({ field }) =>
														<Select
															{...field}
															options={regions}
															value={regions.find(option => option.id === getValues('regionId')) || ''}
															onChange={(option => selectRegion(option))}
															placeholder=""
															noOptionsMessage={() => t('LIST_IS_EMPTY')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>}
												/>
												<span className="text-danger text-sm">{errors?.regionId?.message}</span>
											</div>
											<div className="form-group">
												<label>{t('CITY')}<span className="required-mark">*</span></label>
												<Controller
													name="cityId"
													control={control}
													render={({ field }) =>
														<Select
															{...field}
															options={cities}
															value={cities.find(option => option.id === getValues('cityId')) || ''}
															onChange={(e) => setValue('cityId', e.id, { shouldValidate: true, shouldDirty: true })}
															placeholder=""
															noOptionsMessage={() => t('LIST_IS_EMPTY')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>}
												/>
												<span className="text-danger text-sm">{errors?.cityId?.message}</span>

											</div>
											</div>
											{/* Diler linki orqali kirilgan bo'lsa — diler avtomatik biriktiriladi, mijoz tanlamaydi */}
											{lockedDealerId != null ? (
												<div className="form-group">
													<label>{t('MANAGER')}</label>
													<input
														type="text"
														className="form-control"
														disabled
														value={
															lockedDealer
																? lockedDealer.firstName + (lockedDealer.lastName ? `, ${lockedDealer.lastName}` : '')
																: ''
														}
													/>
												</div>
											) : (
												<div className="form-group">
													<label>{t('MANAGER')}</label>
													<Controller
														name="managerId"
														control={control}
														render={({ field }) =>
															<Select
																{...field}
																options={managerData}
																value={managerData.find(option => option?.id === getValues('managerId'))}
																placeholder=""
																onChange={(e) => setValue('managerId', e.id, { shouldValidate: true, shouldDirty: true })}
																noOptionsMessage={() => t('LIST_IS_EMPTY')}
																getOptionLabel={(option) =>
																	option ? option.firstName + (option.lastName ? `, ${option.lastName}` : '') : ''
																}
																getOptionValue={(option) => option?.id}
															/>}
													/>
													<span className="text-danger text-sm">{errors.regionId}</span>
												</div>
											)}
											<div className="form-group">
												<label>{t('TIN')}</label>
												<input
													type="text"
													inputMode="numeric"
													className="form-control"
													name="tin"
													maxLength={9}
													placeholder="123456789"
													{...register('tin')}
													onChange={handleTinChange}
												/>
												{orgInfo?.status === 'loading' && (
													<div className="text-muted text-sm mt-1">
														<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
														{t('Yuklanmoqda...')}
													</div>
												)}
												{orgInfo?.status === 'found' && (
													<div className="org-info-box mt-2">
														<div className="org-info-name">{orgInfo.data.name}</div>
														{orgInfo.data.status && (
															<div className="org-info-row">{t('STATUS')}: {orgInfo.data.status}</div>
														)}
														{orgInfo.data.registrationDate && (
															<div className="org-info-row">{t("Ro'yxatdan o'tgan")}: {orgInfo.data.registrationDate}</div>
														)}
														{orgInfo.data.address && (
															<div className="org-info-row org-info-address">{orgInfo.data.address}</div>
														)}
													</div>
												)}
												{orgInfo?.status === 'empty' && (
													<div className="text-muted text-sm mt-1">{t("Bu STIR bo'yicha ma'lumot topilmadi")}</div>
												)}
												{orgInfo?.status === 'error' && (
													<div className="text-muted text-sm mt-1">{t("Ma'lumotni olishda xatolik. STIR qo'lda kiritilgan holicha saqlanadi")}</div>
												)}
											</div>

											<div className="form-grid">
												<div className="form-group">
													<label>{t('LOGIN')}<span className="required-mark">*</span></label>
													<input
														type="text"
														className="form-control"
														name="userLogin"
														{...register('userLogin', {
															required: errors.userLogin?.message,
															pattern: {
																value: /^[a-z0-9_]+$/,
																message: 'Only lowercase letters, numbers, and underscores are allowed'
															}
														})}
														onChange={handleLoginChange}
													/>
													<span className="text-danger text-sm">{errors.userLogin?.message}</span>
												</div>

												<div className="form-group">
													<label>{t('PASSWORD')}<span className="required-mark">*</span></label>
													<input type="text" className="form-control" name="password"
														{...register('password', { required: true })}
														onChange={(e) => {
															validatePassword(e.target.value)
														}}
													/>
													<span className="text-danger text-sm">{errors.password?.message}</span>
													{validData.isValid === 5 &&
														<div className="text-danger text-sm">Parol harf va raqamlardan iborat bo‘lishi kerak</div>
													}
												</div>
											</div>
											{showAllowExistingCheckbox && (
												<div className="form-check mt-2">
													<input
														className="form-check-input"
														type="checkbox"
														id="allowExistingLogin"
														checked={allowExistingLogin}
														onChange={() => setAllowExistingLogin(!allowExistingLogin)}
													/>
													<label className="form-check-label" htmlFor="allowExistingLogin">
														{t("Mavjud foydalanuvchi uchun savdo nuqtasini qo'shish")}
													</label>
													<hr></hr>
												</div>

											)}

											<div className="d-flex w-100 mt-4">
												<button type="button" className="btn btn-outline-secondary w-50 me-2" onClick={prevStep} disabled={isStepLoading}>{t('BACK')}</button>
												<button type="button" className="btn btn-success w-50" onClick={() => nextStep(2)} disabled={isStepLoading}>
													{isStepLoading ? (
														<>
															<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
															{t('Yuklanmoqda...')}
														</>
													) : t('NEXT')}
												</button>
											</div>
										</div>

										<div className={`form-step ${isAnimating ? 'fade-out' : 'fade-in'}`} style={{ display: activeStep === 2 ? 'block' : 'none' }}>
											<div className="form-group">
												{activeStep === 2 && <MapSelector onChange={(loc) => setLocationData(loc)} />}
											</div>
											<div className="d-flex w-100 mt-4">
												<button type="button" className="btn btn-outline-secondary w-50 me-2" onClick={prevStep} disabled={isStepLoading}>{t('BACK')}</button>
												<button type="button" className="btn btn-success w-50" onClick={() => nextStep(3)} disabled={isStepLoading}>
													{isStepLoading ? (
														<>
															<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
															{t('Yuklanmoqda...')}
														</>
													) : t('NEXT')}
												</button>
											</div>
										</div>

										<div className={`form-step ${isAnimating ? 'fade-out' : 'fade-in'}`} style={{ display: activeStep === 3 ? 'block' : 'none' }}>
											<h4 className="text-center">{t("Ustanovka pulini to'lash")}</h4>

											<div
												className="d-grid"
												style={{
													textAlign: 'center',
													marginTop: '20px',
												}}
											>
												<label style={{ marginBottom: '10px', display: 'block' }}>
													{t('Belgilangan ustanovka summasini kiriting')}
												</label>

												<input
													type="number"
													name="FixedUstanovkaSumma"
													value={text}
													// min={10000}\
													required={false}
													{...register('fixedUstanovkaSumma')}
													style={{
														width: '250px',
														margin: '0 auto', // markazga joylashish
														padding: '8px',
														fontSize: '16px',
														border: '1px solid #ccc', // kulrang border
														borderRadius: '5px',
														display: 'block', // markazlashish uchun muhim
													}}
													onChange={(e) => {
														handleChange(e.target.value);
														setValue('fixedUstanovkaSumma', e.target.value);
													}}
												/>
											</div>



											<div
												className="d-flex justify-content-center align-items-center w-100"
												style={{ gap: '16px', flexWrap: 'nowrap', overflowX: 'auto' }}
											>
												{/* CLICK kartasi */}
												<div
													className="p-3 text-center d-flex justify-content-center align-items-center"
													style={{ flexDirection: 'column', width: '180px', minWidth: '160px' }}
												>
													<span className="mb-1">CLICK ilovasi orqali to'lang</span>
													<a
														href={`${ClickedSum}`}
														target="_blank"
														style={{
															border: "1px solid #34C38F",
															width: "100%",
															aspectRatio: "1 / 1",
															borderRadius: "10px"
														}}
														className="p-2 d-grid justify-content-center align-items-center text-center cursor payment_card"
													>
														<div className="d-flex flex-column align-items-center gap-2">
															<img
																style={{ width: "60px", height: "60px", borderRadius: "50%" }}
																src={ClickImage}
															/>
															<h5 className="click">CLICK</h5>
														</div>
													</a>
												</div>

												{/* QR kartasi */}
												<div
													className="p-3 text-center d-flex justify-content-center align-items-center"
													style={{ flexDirection: 'column', width: '180px', minWidth: '160px' }}
												>
													<span className="mb-1">QR scaner orqali to'lang</span>
													<div
														style={{
															border: "1px solid #34C38F",
															width: "100%",
															aspectRatio: "1 / 1",
															borderRadius: "10px"
														}}
														className="p-2 d-grid justify-content-center align-items-center text-center cursor payment_card"
													>
														<div className="d-grid gap-2">
															<img
																style={{ width: "100%", height: "100%", objectFit: "contain" }}
																src={qrImage}
															/>
														</div>
													</div>
												</div>
											</div>


											<div className="d-flex w-100 mt-4 align-items-center justify-content-between btn-row">
												<button type="button" className="btn btn-outline-secondary w-50 me-2" style={{ height: '40px' }} onClick={prevStep} disabled={isSubmitting}>
													{t("BACK")}
												</button>
												<div>
													<button type="submit" className="btn btn-success w-100 my-2" disabled={isSubmitting}>
														{isSubmitting ? (
															<>
																<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
																{t("Yuborilmoqda...")}
															</>
														) : t("Ustanovka pulisiz davom etish")}
													</button>
													<button type="submit" className="btn btn-success w-100" disabled={isSubmitting}>
														{isSubmitting ? (
															<>
																<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
																{t("Yuborilmoqda...")}
															</>
														) : t("SEND")}
													</button>
												</div>
											</div>
										</div>

									</form>
								</div>
							</div>
						</div>
					</div>

					<ul className="circles">
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
					</ul>
				</div>
			</div>


			{Modal && (
				<div className="modal-backdrop">
					<div className="modal-box shadow-lg">
						<h4 className="text-success mb-3">✅ {t("Ro'yxatdan o'tish yakunlandi")}</h4>
						<p className="text-muted">{t("Arizangiz yuborildi.")}</p>

						<div className="modal-links mt-4">
							<a
								href={`${process.env.REACT_APP_PROD_SERVER_URL}/`}
								target="_blank"
								rel="noopener noreferrer"
								className="modal-link"
							>
								<span role="img" aria-label="Admin">🔐</span> Admin panelga kirish
							</a>
							<a
								href={DownloadUrlCash}
								target="_blank"
								rel="noopener noreferrer"
								className="modal-link"
							>
								<span role="img" aria-label="Download">💾</span> Kassani yuklab olish
							</a>
						</div>

						<button
							className="btn btn-success w-100 mt-4"
							onClick={() => window.location.reload()}
						>
							OK
						</button>
					</div>
				</div>
			)}





			<style jsx>{`
			/* Ikki ustunli qatorlar: keng ekranda yonma-yon, telefonda ustma-ust */
				.form-grid {
					display: grid;
					grid-template-columns: 1fr;
					column-gap: 14px;
				}
				@media (min-width: 576px) {
					.form-grid {
						grid-template-columns: 1fr 1fr;
					}
				}
				/* Grid ichidagi react-select o'z ustunidan chiqib ketmasligi uchun */
				.form-grid .form-group {
					width: 100%;
					min-width: 0;
				}

			/* Mobil moslashuv (responsive) uchun tuzatishlar */
				@media (max-width: 768px) {
					.form-group {
						width: 100% !important;
					}
					.custom-stepper .step-container {
						flex-direction: row;
						gap: 10px;
					}
						.step-line{
							display: none;
						}
				}

				@media (max-width: 575.98px) {
					.auth-card {
						padding: 14px !important;
					}
					/* 16px — iOS'da inputga bosilganda sahifa zoom bo'lib ketmasligi uchun */
					.form-control,
					.input-group-text {
						font-size: 16px;
						min-height: 44px;
					}
					.step-number {
						width: 26px;
						height: 26px;
						font-size: 13px;
					}
					.step-title {
						font-size: 10px;
						line-height: 1.2;
					}
					.custom-stepper .step-container {
						gap: 6px;
					}
					.org-info-box {
						font-size: 12px;
					}
					/* "Akaunt ma'lumotlari" qadami telefonda bir ekranga sig'sin:
					   oraliqlar ixcham, juftliklar esa quyiroqdagi media'da yonma-yon */
					.step-account .form-group {
						margin-bottom: 8px;
					}
					.step-account label {
						font-size: 12px;
						margin-bottom: 2px;
					}
					.step-account .form-control {
						min-height: 40px;
					}
					.step-account .org-info-box {
						padding: 8px 10px;
						font-size: 11.5px;
					}
					.step-account .org-info-name {
						font-size: 13px;
					}
					/* Uzun manzil ikki qatordan oshmasin */
					.step-account .org-info-address {
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}

					/* Uzun matnli tugmalar qatori telefonda ustma-ust tushsin */
					.btn-row {
						flex-direction: column;
						align-items: stretch !important;
						gap: 8px;
					}
					.btn-row > * {
						width: 100% !important;
						margin-right: 0 !important;
					}
				}

				/* Hudud|Tuman va Login|Maxfiy so'z telefonda ham yonma-yon.
				   320px'lik juda tor ekranlarda ustma-ust qoladi. */
				@media (min-width: 360px) and (max-width: 575.98px) {
					.step-account .form-grid {
						grid-template-columns: 1fr 1fr;
						column-gap: 10px;
					}
				}

				.form-step {
					transition: opacity 0.5s ease;
				}
				/* STIR bo'yicha topilgan tashkilot ma'lumoti */
				.org-info-box {
					background: #f6fbf8;
					border: 1px solid #cdeadb;
					border-radius: 8px;
					padding: 10px 12px;
					font-size: 13px;
					color: #475467;
				}
				.org-info-name {
					font-weight: 600;
					color: #101828;
					margin-bottom: 2px;
				}
				.org-info-row {
					line-height: 1.5;
					overflow-wrap: anywhere;
				}
				.fade-in {
					opacity: 1;
				}
				.fade-out {
					opacity: 0;
				}
				.custom-stepper {
					margin-bottom: 20px;
				}
				.step-container {
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.step {
					display: flex;
					flex-direction: column;
					align-items: center;
					position: relative;
					z-index: 1;
				}
				.step-number {
					width: 30px;
					height: 30px;
					border-radius: 50%;
					background-color: #e0e0e0;
					color: #757575;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: bold;
					margin-bottom: 5px;
					transition: all 0.3s ease;
				}
				.step.active .step-number {
					background-color: #2CA67A;
					color: white;
				}
				.step-title {
					font-size: 12px;
					color: #757575;
					transition: all 0.3s ease;
				}
				.step.active .step-title {
					color: #2CA67A;
					font-weight: bold;
				}
				.step-line {
					width: 100%;
					max-width: 200px;
					height: 3px;
					background-color: #e0e0e0;
					margin: 0 10px;
					top: -15px;
					transition: all 0.3s ease;
				}

				.modal-backdrop {
					position: fixed;
					top: 0; left: 0;
					width: 100vw;
					height: 100vh;
					background: rgba(0,0,0,0.5);
					z-index: 999999999;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.modal-box {
					background: white;
					padding: 30px;
					border-radius: 12px;
					text-align: center;
					width: 90%;
					max-width: 420px;
					animation: fadeIn 0.3s ease;
				}

				.modal-links {
					display: flex;
					flex-direction: column;
					gap: 12px;
					margin-top: 15px;
				}

				.modal-link {
					background: #f8f9fa;
					padding: 12px;
					border-radius: 8px;
					color: #212529;
					text-decoration: none;
					font-weight: 500;
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 8px;
					transition: background 0.3s;
				}

				.modal-link:hover {
					background: #e2e6ea;
					color: #25b17b;
				}

				@keyframes fadeIn {
					from { opacity: 0; transform: scale(0.95); }
					to { opacity: 1; transform: scale(1); }
				}


			`}</style>
		</>
	)
}

export default Register;